import React from 'react';

const DocsView = () => {
  return (
    <div>
      <p>
        There are 2 APIs which we currently supply, the Provider Directory API and the Patient Access API.
      </p>
      <p>
        The Provider Directory API is for third-party applications to obtain information about providers and organizations here at ACCares. 
        Documentation regarding access and usage of the API can be found <a href="/docs/provider-directory">HERE</a>.
      </p>
      <p>
        The Patient Access API is a FHIR API which enables individuals access to their own medical records. Documentation regarding access 
        and usage of the Patient Access API can be found <a href="/docs/patient-access">HERE</a>.
      </p>
    </div>
  );
};

export default DocsView;